import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";

export const useRealtimeMessageNotifications = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const currentEmployeeId = localStorage.getItem('currentEmployeeId');

  useEffect(() => {
    if (!currentEmployeeId) return;

    // Subscribe to new messages for user's conversations
    const channel = supabase
      .channel('new-messages-notifications')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'messages'
        },
        async (payload) => {
          const newMessage = payload.new;
          
          // Check if this message is for current user and not sent by current user
          if (newMessage.sender_id !== currentEmployeeId) {
            // Check if user is participant in this conversation
            const { data: participation } = await supabase
              .from('conversation_participants')
              .select('*')
              .eq('conversation_id', newMessage.conversation_id)
              .eq('employee_id', currentEmployeeId)
              .eq('is_active', true)
              .single();

            if (participation) {
              // Get sender info
              const { data: sender } = await supabase
                .from('employees')
                .select('name')
                .eq('id', newMessage.sender_id)
                .single();

              // Show notification
              toast({
                title: `رسالة جديدة من ${sender?.name || 'موظف'}`,
                description: newMessage.content.length > 50 
                  ? newMessage.content.substring(0, 50) + '...'
                  : newMessage.content,
                duration: 5000,
              });

              // Update queries
              queryClient.invalidateQueries({ queryKey: ['unread-messages-count'] });
              queryClient.invalidateQueries({ queryKey: ['conversations'] });
            }
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [currentEmployeeId, queryClient, toast]);
};

export default useRealtimeMessageNotifications;